import React from 'react';
import { FaChartLine, FaUsers, FaFileAlt, FaShieldAlt, FaLeaf } from 'react-icons/fa';
import {
  ProfileCard,
  CardTitle,
  CardContent,
  ProposalList,
  ProposalItem,
  ProposalIcon,
  ProposalText,
} from './styles';

const items = [
  {
    icon: <FaUsers />,
    text: 'Banca obtenida en el Concejo Deliberante de San Nicolás (legislativas 2025) por La Libertad Avanza, en alianza con Primero San Nicolás.',
  },
  {
    icon: <FaChartLine />,
    text: 'Crecimiento sostenido de presencia digital: +6.7K seguidores agregados en redes oficiales durante el ciclo electoral 2025.',
  },
  {
    icon: <FaFileAlt />,
    text: 'Plan San Nicolás Libertario presentado en agosto 2025: documento de propuestas con horizonte 2025–2029.',
  },
  {
    icon: <FaShieldAlt />,
    text: 'Coalición territorial sostenida con referentes barriales y sectores productivos del cordón portuario.',
  },
  {
    icon: <FaLeaf />,
    text: 'Posicionamiento público sobre humedales y planificación urbana, diferenciándose dentro del espacio LLA.',
  },
];

const AchievementsSection = () => {
  return (
    <ProfileCard>
      <CardTitle>Logros Destacados</CardTitle>
      <CardContent>
        <ProposalList>
          {items.map((it, i) => (
            <ProposalItem key={i}>
              <ProposalIcon>{it.icon}</ProposalIcon>
              <ProposalText>{it.text}</ProposalText>
            </ProposalItem>
          ))}
        </ProposalList>
      </CardContent>
    </ProfileCard>
  );
};

export default AchievementsSection;
